import { render, staticRenderFns } from "./BarcodeControl.vue?vue&type=template&id=487f63a4&scoped=true&"
import script from "./BarcodeControl.vue?vue&type=script&lang=js&"
export * from "./BarcodeControl.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeControl.vue?vue&type=style&index=0&id=487f63a4&lang=scss&scoped=true&"
import style1 from "./BarcodeControl.vue?vue&type=style&index=1&media=print&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487f63a4",
  null
  
)

export default component.exports